export default "__VITE_ASSET__ahRskrMt__"